const accordionButtons = document.querySelectorAll('.accordion-btn');

accordionButtons.forEach(button => {
  button.addEventListener('click', () => {
    const dataAccordion = button.dataset.accordion;
    console.log(dataAccordion);
    const accordion = document.querySelector(`.accordion[data-accordion-toggle="${dataAccordion}"]`);
    // toggle is-active
    button.classList.toggle('is-active');
    accordion.style.display = accordion.style.display === 'none' ? 'block' : 'none';
  });
});